export function checklistDetailTypes() {
  return [
    { code: 'D', name: 'Selection' },
    { code: 'P', name: 'Photo' },
    { code: 'N', name: 'Note' },
    { code: 'NB', name: 'Note with Barcode' },
    { code: 'C', name: 'Checkbox' },
    { code: 'RV', name: 'Record Video' },
    { code: 'NN', name: 'Note Number' },
    { code: 'SCA', name: 'Screen Capture Alert' },
    { code: 'SCAS', name: 'Screen Capture Activation Sensor' },
    { code: 'SCSS', name: 'Screen Capture Sensor Setting' },
    { code: 'SCFC', name: 'Screen Capture Fuel Calibration' },
    { code: 'SCV', name: 'Screen Capture Value (sensor)' },
    { code: 'SCVS', name: 'Screen Capture Video Streaming' },

    { code: 'SCVSH', name: 'Screen Capture Video Streaming Vss' },
    { code: 'SCOC', name: 'Screen Capture Online Command' },
    { code: 'SCC', name: 'Screen Capture CutOff' },
    { code: 'SCFR', name: 'Screen Capture Fuel Raw' },
    { code: 'SCAT', name: 'Screen Capture Alert TrackVision' },
    { code: 'SCM', name: 'Screen Capture Map' },
    { code: 'SCFV', name: 'Screen Capture File (history) Video' },
    { code: 'STC', name: 'Screen Capture Total Camera' },
    { code: 'U', name: 'Upload' },
    { code: 'SCTZ', name: 'Screen Capture Time Zone' },
    { code: 'SCCOC', name: 'Screen Capture Custom Online Command' },
    { code: 'SCB', name: 'Screen Capture (eye) Beacon' },
    { code: 'SCCD', name: 'Screen Capture Change Device' },
    { code: 'SCCS', name: 'Screen Capture Change Simcard' },
    { code: 'SCTWC', name: 'Screen Capture Two Way Communication' },
    { code: 'SCTWCH', name: 'Screen Capture Two Way Communication Howen' },

    { code: 'SCRC', name: 'Screen Capture Raw Command' },
    { code: 'SCWD', name: 'Screen Capture Work Disk' },
    { code: 'SCDB', name: 'Screen Capture Driver Behaviour' },
    { code: 'SPAH', name: 'Select Profile ADAS Howen' },
    { code: 'SPDH', name: 'Select Profile DMS Howen' },
    { code: 'SCTC', name: 'Screen Capture Temperature Calibration' },
    { code: 'NND', name: 'Note Number Decimal' },
    { code: 'SCCVSGS', name: 'Screen Capture Vehicle Status GSM Signal' },
    { code: 'SCCVSGPSS', name: 'Screen Capture Vehicle Status GPS Sattelite' },
    { code: 'SCOBD', name: 'Screen Capture OBD Status' },
    { code: 'SCATH', name: 'Screen Capture Alert TrackVision Howen' },

    { code: 'SCAVI', name: 'Screen Capture Auto Validation Ignition' },
    { code: 'SCAVV', name: 'Screen Capture Auto Validation Voltage' },
    { code: 'SCAVS', name: 'Screen Capture Auto Validation Satellite' },

    // for Transjakarta Apps
    { code: 'SCTWCBP', name: 'Screen Capture Two Way Communication BSJ Platform' },
    { code: 'SCMBP', name: 'Screen Capture Map BSJ Platform' },
    { code: 'SCSABP', name: 'Screen Capture Simulasi ADAS BSJ Platform' },
    { code: 'SCSDBP', name: 'Screen Capture Simulasi DMS BSJ Platform' },
    { code: 'SCVSBP', name: 'Screen Capture Video Streaming BSJ Platform' },
    { code: 'SCOCBP', name: 'Screen Capture Online Command BSJ Platform' },
    { code: 'TCFA', name: 'Task Checklist Finding Action' },
    { code: 'SCSCP', name: 'Screen Capture Send Custom Profile' },
  ]
}
